import React from "react";
import { useMultiSelect } from "../hooks/use-multi-select";
export var DropdownHeader = () => {
  var {
    t,
    value,
    options,
    valueRenderer
  } = useMultiSelect();
  var noneSelected = value.length === 0;
  var allSelected = value.length === options.length;
  var customText = valueRenderer && valueRenderer(value, options);

  var getSelectedText = () => value.map(s => s.label).join(", ");

  return noneSelected ? /*#__PURE__*/React.createElement("span", {
    className: "gray"
  }, customText || t("selectSomeItems")) : /*#__PURE__*/React.createElement("span", null, customText || (allSelected ? t("allItemsAreSelected") : getSelectedText()));
};
//# sourceMappingURL=header.js.map